import type { ISODateString } from '@/shared/types/common';
import type { PersonId } from '@/shared/types/profile';

export interface MilestoneData {
  profile_id: PersonId;
  occurred_at: ISODateString;
  milestone_id: string;
  created_at: ISODateString;
  created_by: string;
  deleted_at: ISODateString;
  next_occurrence: ISODateString;
  fullname: string;
}

export interface Milestone {
  id: string;
  data: MilestoneData;
}

export interface MilestoneCreate {
  id: string;
  data: Omit<
    MilestoneData,
    'created_at' | 'deleted_at' | 'next_occurrence' | 'fullname'
  >;
}

export type MilestoneUpdate = Partial<
  Omit<MilestoneData, 'created_at' | 'next_occurrence' | 'fullname'>
>;

export interface State {
  list: Milestone[];
  loaded: boolean;
}

export interface MilestoneEntry {
  id: string;
  label: string;
  icon: string;
}

export const MilestoneEntries: MilestoneEntry[] = [
  {
    id: 'birthday',
    label: 'Birthday',
    icon: 'mdi:cake-variant',
  },
  {
    id: 'wedding',
    label: 'Anniversary',
    icon: 'mdi:ring',
  },
  {
    id: 'baptism',
    label: 'Baptism',
    icon: 'mdi:water',
  },
];

export const MilestoneLookup: Record<string, MilestoneEntry> =
  MilestoneEntries.reduce(
    (m, v) => {
      m[v.id] = v;

      return m;
    },
    {} as Record<string, MilestoneEntry>,
  );
